//import { RegulatorStatus } from '../../enums/regulator/regulator-status';

export class RegulationDetail {
  id: number;
  regulationId: number;
  title: string;
  type: string;
  status: number;
  comment: string;
  jurisdiction: string;
  isRead: boolean;
  userId: string;
  filterType: string;
  linkedIds: string;
  similarIndex: string;
  selectedLinkedIds: number[];
  regulatorId: number;
  regulator: string;
  TabType:string;
  FileName:string;
  FileType:string;
  FileUrl:string;
  FileExtension:string;
  constructor() {
    this.id = 0;
    this.regulationId = 0;
    this.title = '';
    this.type = '';
    this.status = 0;
    this.comment = '';
    this.jurisdiction = '';
    this.isRead = false;
    this.userId = '';
    this.filterType = '';
    this.linkedIds = '';
    this.similarIndex = '';
    this.selectedLinkedIds = [];
    this.regulatorId = 0;
    this.regulator = '';
    this.TabType=''
    this.FileName='';
    this.FileExtension='';
    this.FileType='';
    this.FileUrl='';
  }
}

export class RegulationDetailDto {
  regulationDetails: RegulationDetail;
  screenName: string;

  constructor() {
    this.regulationDetails = new RegulationDetail();
    this.screenName = '';
  }
}
